import api from '../api/axios';

function buildParams({ startDate, endDate, employeeId } = {}) {
  const params = { startDate, endDate };
  if (employeeId) params.employeeId = employeeId;
  return params;
}

export const getRecruiterTlRequirementDetails = (filters = {}) =>
  api
    .get('/api/admin/recruiter-tl-requirement-details', { params: buildParams(filters) })
    .then((r) => r.data);
